const keymap ={
    "region:relation": {
    "key": "alt+w",
    "description": "Create relation between regions"
  }
}

export default keymap;